import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { AdobeXDIcon, AdobeXDSearchResultIcon } from './icon';

export const adobeXDConfig: ThirdPartyConfig = {
	displayName: 'AdobeXD',
	id: 'adobexd',
	resourceType: ProductResourceTypes3P.AdobeXD,
	icon: get3PLogo(AdobeXDIcon, 'AdobeXD', 'medium'),
	searchResultIcon: get3PLogo(AdobeXDSearchResultIcon, 'AdobeXD', 'large'),
	integrationAri: 'ari:cloud:platform::integration/adobe',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
